<template>
<div class="chapter">
<div class="inner_page">
<p class="P_TOC_Heading" id="tableofcontents">Table of Contents</p>
<p class="P_TOC_Entry_1"><a href="#/section0002#auto_bookmark_toc_2">Blurb</a></p>
<p class="P_TOC_Entry_1"><a href="#/section0003#auto_bookmark_toc_3">Dedication</a></p>
<p class="P_TOC_Entry_1"><a href="#/section0004#auto_bookmark_toc_5">Prologue</a></p>
<p class="P_TOC_Entry_1"><a href="#/section0005#auto_bookmark_toc_7">Chapter 1</a></p>
<p class="P_TOC_Entry_1"><a href="#/section0006#auto_bookmark_toc_9">Chapter 2</a></p>
<p class="P_TOC_Entry_1"><a href="#/section0007#auto_bookmark_toc_11">Chapter 3</a></p>
<p class="P_TOC_Entry_1"><a href="#/section0008#auto_bookmark_toc_13">Chapter 4</a></p>
<p class="P_TOC_Entry_1"><a href="#/section0009#auto_bookmark_toc_15">Chapter 5</a></p>
<p class="P_TOC_Entry_1"><a href="#/section0010#auto_bookmark_toc_17">Chapter 6</a></p>
<p class="P_TOC_Entry_1"><a href="#/section0011#auto_bookmark_toc_19">Chapter 7</a></p>
<p class="P_TOC_Entry_1"><a href="#/section0012#auto_bookmark_toc_21">Chapter 8</a></p>
<p class="P_TOC_Entry_1"><a href="#/section0013#auto_bookmark_toc_23">Chapter 9</a></p>
<p class="P_TOC_Entry_1"><a href="#/section0014#auto_bookmark_toc_25">Chapter 10</a></p>
<p class="P_TOC_Entry_1"><a href="#/section0015#auto_bookmark_toc_27">Epilogue</a></p>
<p class="P_TOC_Entry_1"><a href="#/section0016#auto_bookmark_toc_28">About the Author</a></p>
<p class="P_TOC_Entry_1"><a href="#/section0017#auto_bookmark_toc_29">More by Andrew Grey</a></p>
<p class="P_TOC_Entry_1"><a href="#/section0018">Visit Dreamspinner Press</a></p>
<p class="P_TOC_Entry_1"><a href="#/section0019#auto_bookmark_toc_32">Copyright</a></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// section-0001.vue?144e8b56